import mapboxgl, { MapLayerEventType } from 'mapbox-gl'

type MapEvents = Record<
  keyof MapLayerEventType,
  {
    timeout: NodeJS.Timeout | null
    listeners: Record<string, (event: MapLayerEventType[keyof MapLayerEventType]) => void>
  }
>
const current = new Map<mapboxgl.Map, MapEvents>()

export default function addUpperLayerEventListener<EventName extends keyof MapLayerEventType>(
  map: mapboxgl.Map,
  eventName: EventName,
  layersIds: string[],
  listener: (event: MapLayerEventType[EventName]) => void,
) {
  const handleEvent = (event: MapLayerEventType[EventName]) => {
    const currentMapEvents = current.get(map)
    const mapEvents: MapEvents = currentMapEvents ?? ({} as MapEvents)
    if (!currentMapEvents) {
      current.set(map, mapEvents)
    }

    mapEvents[eventName] = mapEvents[eventName] ?? { timeout: null, listeners: {} }
    if (mapEvents[eventName].timeout !== null) {
      clearTimeout(mapEvents[eventName].timeout!)
    }

    mapEvents[eventName].listeners[layersIds[0]] = listener as (
      event: MapLayerEventType[keyof MapLayerEventType],
    ) => void
    mapEvents[eventName].timeout = setTimeout(() => {
      const listeners = mapEvents[eventName].listeners
      delete mapEvents[eventName]
      if (Object.keys(mapEvents).length === 0) {
        current.delete(map)
      }

      const layers = map.getStyle().layers.map(layer => layer.id)
      const listenersKeys = Object.keys(listeners)
      const indexes = listenersKeys.map(key => layers.indexOf(key))
      const maxIndex = Math.max(...indexes)

      const selectedLayer = layers[maxIndex]
      const selectedListener = listeners[selectedLayer]

      if (selectedListener) selectedListener(event)
    }, 200)
  }

  map.on(eventName, layersIds, handleEvent)

  return () => {
    map.off(eventName, layersIds, handleEvent)
  }
}
